import { FieldDef, GroupDef, GuiDef, ValidatorDef, TabDefinition, CollapsableDef } from '@/objects/gui';
import { Timepenalty } from '@/objects/generated';
import { markRaw, computed } from 'vue';
import { InputText, ValidatedText, InputTimespan, DisplayTimespan, InputFloat, ValidatedFloat } from '@/components';
import { type DateType } from '@/utilities/dateutils';
import type { SelectLine, SelectLineValueType } from '@/objects/SelectLine';

export class TimepenaltyGuiDef extends GuiDef<Timepenalty> {
    constructor() {
        super('Timepenalty');

        const Reason = new FieldDef<Timepenalty>();
        Reason.Name = 'Reason';
        Reason.FieldName = 'Reason';
        Reason.DefinedFor = 'Both';
        Reason.TranslationKey = 'timepenalty.reason';
        Reason.Editable = true;
        Reason.Filterable = false;
        Reason.Sortable = false;
        Reason.CssClasses = '';
        Reason.value = (timepenalty) => timepenalty.Reason;
        Reason.setValue = (timepenalty, value) => (timepenalty.Reason = value);
        Reason.DetailEditor = markRaw(InputText);
        Reason.DetailEditorProps = {};
        Reason.CellEditor = markRaw(InputText);
        Reason.CellEditorProps = {};
        Reason.CellRenderer = markRaw(ValidatedText);
        Reason.CellRendererProps = {};
        Reason.Validator = null;
        Reason.SortDirection = undefined;
        Reason.cellClassRules = undefined;
        Reason.MinWidth = 500;
        Reason.MaxWidth = undefined;
        Reason.Tooltip = null;
        this.Fields.push(Reason);

        const Penalty = new FieldDef<Timepenalty>();
        Penalty.Name = 'Penalty';
        Penalty.FieldName = 'Penalty';
        Penalty.DefinedFor = 'Both';
        Penalty.TranslationKey = 'timepenalty.penalty';
        Penalty.Editable = true;
        Penalty.Filterable = false;
        Penalty.Sortable = true;
        Penalty.CssClasses = '';
        Penalty.value = (timepenalty) => timepenalty.Penalty;
        Penalty.setValue = (timepenalty, value) => (timepenalty.Penalty = value);
        Penalty.DetailEditor = markRaw(InputTimespan);
        Penalty.DetailEditorProps = { format: 'TIME' as DateType };
        Penalty.CellEditor = markRaw(InputTimespan);
        Penalty.CellEditorProps = { format: 'TIME' as DateType };
        Penalty.CellRenderer = markRaw(DisplayTimespan);
        Penalty.CellRendererProps = { format: 'TIME' as DateType };
        Penalty.Validator = null;
        Penalty.SortDirection = undefined;
        Penalty.cellClassRules = undefined;
        Penalty.MinWidth = 100;
        Penalty.MaxWidth = 100;
        Penalty.Tooltip = null;
        this.Fields.push(Penalty);

        const Km = new FieldDef<Timepenalty>();
        Km.Name = 'Km';
        Km.FieldName = 'Km';
        Km.DefinedFor = 'Both';
        Km.TranslationKey = 'timepenalty.km';
        Km.Editable = true;
        Km.Filterable = false;
        Km.Sortable = true;
        Km.CssClasses = '';
        Km.value = (timepenalty) => timepenalty.Km;
        Km.setValue = (timepenalty, value) => {
            if (value === null || value === undefined || value === '' || isNaN(value)) {
                value = 0;
            }
            timepenalty.Km = value;
        };
        Km.DetailEditor = markRaw(InputFloat);
        Km.DetailEditorProps = {};
        Km.CellEditor = markRaw(InputFloat);
        Km.CellEditorProps = {};
        Km.CellRenderer = markRaw(ValidatedFloat);
        Km.CellRendererProps = { decimal: 3 };
        Km.Validator = null;
        Km.SortDirection = undefined;
        Km.cellClassRules = undefined;
        Km.MinWidth = 100;
        Km.MaxWidth = 100;
        Km.Tooltip = null;
        this.Fields.push(Km);
    }

    public async LoadDependencies() {}
}
